export enum StoreType {
  RETAIL = 'retail',
  FNB = 'F&B',
}
